import React from 'react';
import moment from 'moment'
import { SendEmailCampaign } from "../actionButtons/SendEmailCampaign";
import { ViewEmailCampaign } from '../actionButtons/ViewEmailCampaign';
import { TRANSLATED_EMAIL_CAMPAIGN_RECIPIENTS, TRANSLATED_EMAIL_CAMPAIGN_STATUSES, TRANSLATED_EMAIL_CAMPAIGN_TEMPLATES } from '../../../../config/constants';

function TableRow(props) {
  const { emailCampaign, index } = props;
  if ( ! emailCampaign) {
    return null;
  }

  return (
    <tr>
      <td>{ TRANSLATED_EMAIL_CAMPAIGN_TEMPLATES[emailCampaign.template] }</td>
      <td>{ TRANSLATED_EMAIL_CAMPAIGN_RECIPIENTS[emailCampaign.recipients_type] }</td>
      <td>{ TRANSLATED_EMAIL_CAMPAIGN_STATUSES[emailCampaign.status] }</td>
      <td>{ moment(new Date(emailCampaign.created_at)).format("DD-MM-YYYY") }</td>
      <td className="w-10">
        <ViewEmailCampaign 
          emailCampaign={emailCampaign}
          index={index}
        />
        <SendEmailCampaign 
          emailCampaign={emailCampaign}
          index={index}
          showIcon={true}
          actionCallback={() => props.actionCallback( true )}
        />
      </td>
    </tr>
  )
}

export { TableRow };
